<!-- src/views/AuthCallback.vue -->
<template>
  <div>Procesando inicio de sesión...</div>
</template>

<script setup>
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { useAccount } from '@/core/composables/useAccount'

const { userManager } = useAccount();

onBeforeMount(async () => {
    const router = useRouter();
    
    try {
        const user = await userManager.signinRedirectCallback();
        const target = user?.state?.target || "/chats";
        window.location.replace(target);
    } catch (err) {
        console.error("Error al procesar el callback OIDC:", err);
        router.replace("/");
    }
});
</script>